/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import queryString from "query-string";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { loginNew } from "reducers/session";
import oopsImg from "assets/img/oops.png";
import { showMsgFromJson } from "reducers/common";
import { Spinner } from "components/Spinner";
import Constants from "utilities/appConstants";
/* Project Import will be here */

class UserTokenLogin extends Component {
    componentDidMount() {
        let query = queryString.parse(this.props.location.search);

        if (query && window.enableQueryStringToken && query.userToken)
            return this.props.actions.loginNew({ UserToken: query.userToken });
    }

    renderInvalidAccess = (versionUpdate) => {
        return (
            <div className="text-center">
                <img className="oops-img" src={oopsImg} alt="invalid-user-oops" />
                {versionUpdate ?
                    <p className="p-3 font-bold">{this.props.translate("common.alerts.error.E_INVALID_VERSION")}</p>
                    : <p className="p-3 font-bold">{this.props.translate("common.alerts.error.E015")}</p>}
            </div>
        )
    };

    renderComp = () => {
        let query = queryString.parse(this.props.location.search);

        if (query && query.userToken) {
            if (!this.props.session.isLoading && this.props.session.error && !this.props.wholesalers.isLoading) {
                return this.renderInvalidAccess(this.props.session.error === Constants.INVALID_VERSION)
            }
            else {
                return (
                    <div className="fetching-user-details-spinner">
                        <Spinner needLargeSize={true} message={this.props.translate("common.bimbo.fetchingUserDetails")} />
                    </div>
                )
            }
        }
        else {
            return this.renderInvalidAccess(false)
        }
    }

    render() {
        return (
            this.renderComp()
        );
    }
}

const mapStateToProps = (state) => {
    return {
        location: state.router.location,
        session: state.session,
        wholesalers: state.wholesalers,
        translate: getTranslate(state.locale),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            {
                loginNew,
                showMsgFromJson
            },
            dispatch
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserTokenLogin);